export const redirectWindowToUrl = signupRedirectUrl => {
  window.location.replace(signupRedirectUrl);
};